export default __webpack_public_path__ + "static/media/ragImg.fd4af6ca.svg";